module.exports = __webpack_public_path__ + "bw.svg?ddf2a55fbe1465ceb8d99189bfe38881";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bw.svg
// module id = 961
// module chunks = 27